// src/components/AskGenie/AskGenie.jsx
import React from 'react';
import ThreadList from './ThreadList';
import ChatArea from './ChatArea';
import SourceViewer from './SourceViewer';
import useChat from './useChat';

function AskGenie() {
  const {
    threads,
    activeThreadId,
    threadMessages,
    isLoading,
    error, // Add error
    query,
    selectedCitation,
    setQuery,
    setSelectedCitation,
    handleSelectThread,
    handleNewThread,
    handleDeleteThread,
    handleTemplateClick,
    handleQuerySubmit,
  } = useChat();

  return (
    <div className="main-content p-0 d-flex" style={{ height: '100vh' }}>
      <ThreadList
        threads={threads}
        activeThreadId={activeThreadId}
        handleSelectThread={handleSelectThread}
        handleNewThread={handleNewThread}
        handleDeleteThread={handleDeleteThread}
      />
      <div className="flex-grow-1 d-flex flex-column" style={{ overflowY: 'scroll', maxHeight: '100vh' }}>
        <header className="border-bottom bg-white p-3">
          <h1 className="h4 mb-0">Ask Genie</h1>
        </header>
        <div className="d-flex flex-grow-1">
          <ChatArea
            activeThreadId={activeThreadId}
            threadMessages={threadMessages}
            isLoading={isLoading}
            error={error} // Pass error prop
            query={query}
            setQuery={setQuery}
            handleTemplateClick={handleTemplateClick}
            handleQuerySubmit={handleQuerySubmit}
            setSelectedCitation={setSelectedCitation}
          />
          <SourceViewer
            selectedCitation={selectedCitation}
            setSelectedCitation={setSelectedCitation}
          />
        </div>
      </div>
    </div>
  );
}

export default AskGenie;